import { render, staticRenderFns } from "./ArticleTable.vue?vue&type=template&id=0553edb2&scoped=true"
import script from "./ArticleTable.vue?vue&type=script&lang=js"
export * from "./ArticleTable.vue?vue&type=script&lang=js"
import style0 from "./ArticleTable.vue?vue&type=style&index=0&id=0553edb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553edb2",
  null
  
)

export default component.exports